export const getCurrentLocale = ({
  registry
}) => {
  const _registry$formContext = registry.formContext,
        languages = _registry$formContext.languages,
        defaultLocale = _registry$formContext.defaultLocale,
        currentLocale = _registry$formContext.currentLocale;
  return currentLocale || defaultLocale || languages && languages.length && languages[0] || undefined;
};
export default getCurrentLocale;